import React from 'react';
import PropTypes from 'prop-types';

const DropDownIndicator = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      viewBox="15 15 1000 554.87"
      role="button"
      tabIndex="-1"
    >
      <title>Dropdown Indicator</title>
      <path
        fill={color}
        id="Path_509"
        data-name="Path 509"
        className="cls-1"
        d="M499,776.45l-500-500,54.87-54.88L499,666.7,944.13,221.57,999,276.45Z"
        transform="translate(0.99 -221.57)"
      />
    </svg>
  );
};

export default DropDownIndicator;

DropDownIndicator.propTypes = {
  color: PropTypes.string,
};
